import React, { useEffect, useState } from 'react'
import { Skeleton, Typography, Button, CalendarSelect } from '../../../../components/common'
import { CircleIcon, KeyboardRightIcon } from '../../../../theme/icons2'
import moment from 'moment'
import { useQuery } from '@apollo/client'
import { GET_FRESHDESK_COUNT } from '../../../../grapghQl/queries/freshDesk'
import { CustomModalRoot } from '../../../../components/common/Modal/CustomModalroot'
import { CustomPopup } from '../../../../components/common/CustomPopup'
import { DetailedOverview } from './Details'
import { CheckUserRole } from '../../../../components/common/CheckUserRole'
 
export const FreshDeskOverview = ({ startDate, handleUpdateMonth, tickets = [], setTickets, handleClickFilter = () => null, activeQuery = null, allRows = [] }) => {
    const { isAdmin } = CheckUserRole()
    const [isOpenDialogue, setDialogue] = useState({
        isOpen: false,
        onCloseDialog: () => false,
        children: null,
        className: 'min-w-2xl max-w-2xl'
    })
    const { data, loading } = useQuery(GET_FRESHDESK_COUNT, {
        fetchPolicy: 'no-cache',
        variables: {
            startDate: moment(startDate)?.startOf('month')?.format('YYYY-MM-DD'),
            endDate: moment(startDate)?.endOf('month')?.format('YYYY-MM-DD')
        }
    })

    const { greyTHRTicketsCounts = [] } = data || { greyTHRTicketsCounts: [] }

    const handleOnCloseDialog = () => setDialogue({
        ...isOpenDialogue,
        isOpen: false
    })

    const toggleModal = () => setDialogue({
        ...isOpenDialogue,
        isOpen: true,
        onCloseDialog: () => handleOnCloseDialog(),
        children: <CustomPopup
            children={<DetailedOverview startDate={startDate} onCloseDialogue={handleOnCloseDialog} />}
            onCloseDialog={handleOnCloseDialog}
            content={{ title: `Detailed Overview for ${moment(startDate)?.format('MMMM')} ${moment(startDate)?.format('YYYY')}`, maxWidth: 'max-w-lg' }}
        />
    })

    useEffect(() => {
        if (Object.values(greyTHRTicketsCounts)?.length) {
            const transformedData = Object.entries(greyTHRTicketsCounts).reduce((acc, [key, value]) => {
                const newKey = key.toLowerCase().replace(/\s+/g, '');
                acc[newKey] = value;
                return acc;
            }, {});

            const newTickets = tickets?.length && tickets?.map(ticket => {
                return {
                    ...ticket,
                    count: transformedData?.[ticket?.field]
                }
            })
            setTickets(newTickets);
        }
        //eslint-disable-next-line
    }, [greyTHRTicketsCounts, allRows])

    return (
        <div className='bg-white px-3 py-6 flex flex-col gap-4 relative'>
             
            <CustomModalRoot isOpenDialogue={isOpenDialogue} />
            <div className='flex justify-between items-start'>
                <div>
                    <Typography variant="lg" text="Overview" className="font-semibold" />
                    <Typography variant="base" text="View and analyse your tickets" />
                </div>
                <div className='flex items-start gap-2'>
                    <CalendarSelect renderDate={moment(startDate)?.format('MMM, YYYY')} startDate={startDate} handleUpdateMonth={handleUpdateMonth} />
                 </div>
            </div>
            <div className='flex gap-3'>
                {isAdmin && <div className='flex w-4/5 gap-3 flex-wrap lg:flex-nowrap'>
                    {loading ? <Loader /> : !!tickets?.length && tickets?.map(ticket =>
                        <div role="button" onClick={() => handleClickFilter(ticket)} key={ticket?.title} className={`flex gap-1 flex-col border ${activeQuery === ticket?.query ? 'border-teal-100 bg-teal-100' : 'border-teal-200 bg-teal-50'}  rounded-lg p-3 w-full `}>
                            <Typography variant="2xl" text={String(ticket?.count)} className="font-semibold" />
                            <div className='flex items-center gap-2'>
                                <CircleIcon fill={ticket?.fill} />
                                <Typography variant="base" text={ticket?.title} />
                            </div>
                        </div>)}
                </div>}
                <div className='flex border items-center justify-between border-deep-purple-200 hover:border-deep-purple-100 bg-deep-purple-50 hover:bg-deep-purple-100 rounded-lg p-3 w-1/5'>
                    <div className='w-4/5'>
                        <Typography variant="sm" className="font-semibold" text={'View Detailed Overview of Clients and Users'} />
                    </div>
                    <Button text="" onClick={toggleModal} className="w-fit h-fit" variant="tertiary" icon={<KeyboardRightIcon />} />
                </div>
            </div>
        </div>
    )
}
 
const Loader = () => (<>
    {[0, 1, 2, 3, 4, 5]?.map(loader => <div key={loader} className={`flex gap-1 flex-col border border-teal-200 rounded-lg p-3 w-1/3 lg:w-full`}>
        <Skeleton length={1} className="h-10 w-full rounded-lg " />
        <div className='flex items-center gap-2'>
            <Skeleton length={1} className="h-5 w-full rounded-lg " />
        </div>
    </div>)}

</>)